import type { JSX } from "react";
import type { McpQuery } from "./mcpAudit";

interface McpQueriesBlockProps {
  goal: string | null;
  queries: McpQuery[];
}

/**
 * The array of queries an MCP search received, rendered as an indented list
 * under the turn goal — one line per independent search path the server ran.
 * Renders nothing for non-MCP actions (no queries array on the audit row).
 */
export default function McpQueriesBlock({ goal, queries }: McpQueriesBlockProps): JSX.Element | null {
  if (queries.length === 0) return null;
  return (
    <div className="mb-3">
      <label className="block text-xs font-medium text-gray-500 mb-1">
        Queries ({queries.length})
      </label>
      {goal && <p className="text-sm text-gray-700">{goal}</p>}
      <ul className="mt-1 ml-1 space-y-1 border-l-2 border-blue-200 pl-4">
        {queries.map((q, index) => (
          <li key={`${index}-${q.query}`} className="text-sm text-gray-700">
            <span className="font-mono">{q.query}</span>
            {q.targetColumns.length > 0 && (
              <span className="ml-2 text-xs text-gray-400">
                → {q.targetColumns.join(", ")}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
